import React from "react";
import "./QboPushVendorsModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../shared/OwLabel/OwLabel";

type Props = {
    closeModalFn: () => void;
    startPushFn: (options: { onlyUnconnected: boolean }) => void;
};

export const QboPushVendorsModal: React.FC<Props> = (props) => {
    const closeModal = () => {
        props.closeModalFn();
    };

    const start = () => {
        props.startPushFn({ onlyUnconnected: true });
    };

    return (
        <div className={"QboPushVendorsModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fas fa-exchange"} title={"push_vendors"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"mt-3"}>
                <OwCheckbox
                    label={"only_push_unconnected_accounts"}
                    fn={() => {}}
                    name={"only_push_unconnected_accounts"}
                    truthyVal={true}
                    falsyVal={false}
                    checked={true}
                    disabled={true}
                />
                <OwLabel className={"text-muted small mt-1"} title={"only_unconnected_vendors_supported"} />
            </div>

            <div className="mt-3">
                <OwButton title={"start"} fn={start} />
            </div>
        </div>
    );
};
